import 'normalize.css';
import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import './global.css';
import '../components/error.css';
